import { Dispatch, FC, SetStateAction } from "react";
import { ITrackSessionQuestions, Question } from "@/utils/types";
import TrackSessionQuestionBlock from "./TrackSessionQuestionBlock";

interface Props {
  questions: ITrackSessionQuestions;
  setSelectedQuestions: Dispatch<SetStateAction<Question[]>>;
}

const TrackSessionQuestionList: FC<Props> = ({
  questions,
  setSelectedQuestions,
}) => {
  return (
    <div className="w-full flex flex-col gap-2 pt-[4px]">
      {Object.keys(questions).map((specType, index) => (
        <TrackSessionQuestionBlock
          title={specType}
          questions={questions[specType]}
          key={index}
          setSelectedQuestions={setSelectedQuestions}
        />
      ))}
    </div>
  );
};

export default TrackSessionQuestionList;
